import { Component, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BaseDataTableFilter } from '../../../../shared/components/data-table/filters/components/data-table-filter/BaseDataTableFilter';
import { DataTableFilterMessageService } from '../../../../shared/components/data-table/filters/components/data-table-filter-message-service';
import { DEPARTURE_DATE_FILTER_ID, ScreeningReportFilterStateService } from '../../services/screening-report-filter-state.service';

@Component({
  selector: 'app-screening-report-date-filter',
  standalone: true,
  imports: [FormsModule, MatDatepickerModule, MatFormFieldModule, MatInputModule],
  templateUrl: './screening-report-date-filter.component.html'
})
export class ScreeningReportDateFilterComponent extends BaseDataTableFilter implements OnDestroy {

  constructor(
    private filterMessageService: DataTableFilterMessageService,
    readonly filterState: ScreeningReportFilterStateService
  ) {
    super(filterMessageService);
  }

  get label(): string {
    return this.id === DEPARTURE_DATE_FILTER_ID ? 'Departing on or before:' : 'Arriving on or after:';
  }

  datePickerOpened(): void {
    this.filterMessageService.setClickoutEnabled(false);
  }

  datePickerClosed(): void {
    this.filterMessageService.setClickoutEnabled(true);
  }

  onApplyClicked(): void {
    this.filterState.changed.next(this.id);
  }

  onClearClicked(): void {
    this.filterState.dates[this.id] = null;
    this.filterState.changed.next(this.id);
  }

  ngOnDestroy(): void {
    this.clearSubscriptions();
  }
}
